var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 0.833496C7.6267 0.833496 0.832031 7.62816 0.832031 16.0002C0.832031 24.3722 7.6267 31.1668 15.9987 31.1668C24.3707 31.1668 31.1654 24.3722 31.1654 16.0002C31.1654 7.62816 24.3707 0.833496 15.9987 0.833496ZM15.9987 6.90016C18.9259 6.90016 21.307 9.28133 21.307 12.2085C21.307 15.1357 18.9259 17.5168 15.9987 17.5168C13.0715 17.5168 10.6904 15.1357 10.6904 12.2085C10.6904 9.28133 13.0715 6.90016 15.9987 6.90016ZM15.9987 28.1335C12.9199 28.1335 9.27986 26.8898 6.68636 23.7655C9.24953 21.7635 12.48 20.5502 15.9987 20.5502C19.5174 20.5502 22.7479 21.7635 25.311 23.7655C22.7175 26.8898 19.0775 28.1335 15.9987 28.1335Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.c344d5b1fa8a3b4cd7a4c224d564aab3.svg";
export { ForwardRef as ReactComponent };